module.exports = __webpack_public_path__ + "static/logo-tripadvisor2-dacc62638881b9267a64e2fc827a515e.png";